import { CollectDataStepStatus, CollectDataStepType } from 'src/constants/collect-data/enums'
import { CollectDataConfig, CollectDataStep } from 'src/interfaces/collectData'

export const backendSortSteps = (steps: CollectDataStep[]): CollectDataStep[] => {
  return steps.sort((a, b) => a.order - b.order)
}

export const clientSortSteps = (steps: CollectDataStep[]): CollectDataStep[] => {
  return steps.sort((a, b) => {
    if (a.type === CollectDataStepType.Form) {
      return -1
    } else if (b.type === CollectDataStepType.Form) {
      return 1
    }

    if (a.type === CollectDataStepType.DriverLicense) {
      return -1
    } else if (b.type === CollectDataStepType.DriverLicense) {
      return 1
    }

    if (a.type === CollectDataStepType.VehicleInsurance) {
      return -1
    } else if (b.type === CollectDataStepType.VehicleInsurance) {
      return 1
    }

    if (a.type === CollectDataStepType.InsuranceDeclaration) {
      return -1
    } else if (b.type === CollectDataStepType.InsuranceDeclaration) {
      return 1
    }

    if (a.type === CollectDataStepType.VehicleRegistration) {
      return -1
    } else if (b.type === CollectDataStepType.VehicleRegistration) {
      return 1
    }

    if (a.type === CollectDataStepType.Vaccination) {
      return -1
    } else if (b.type === CollectDataStepType.Vaccination) {
      return 1
    }

    if (a.type === CollectDataStepType.BGC) {
      return -1
    } else if (b.type === CollectDataStepType.BGC) {
      return 1
    }

    if (a.type === CollectDataStepType.StitchPayment) {
      return -1
    } else if (b.type === CollectDataStepType.StitchPayment) {
      return 1
    }

    if (a.type === CollectDataStepType.InsuranceBeneficiary) {
      return -1
    } else if (b.type === CollectDataStepType.InsuranceBeneficiary) {
      return 1
    }

    if (a.type === CollectDataStepType.SignContract) {
      return -1
    } else if (b.type === CollectDataStepType.SignContract) {
      return 1
    }

    if (a.type === CollectDataStepType.MVR) {
      return -1
    } else if (b.type === CollectDataStepType.MVR) {
      return 1
    }

    if (a.type === CollectDataStepType.EIN) {
      return -1
    } else if (b.type === CollectDataStepType.EIN) {
      return 1
    }

    return -1
  })
}

export const sortByDisabled = (steps: CollectDataConfig[]): CollectDataConfig[] => {
  return steps.sort((a, b) => {
    if (a.disabled && !b.disabled) {
      return 1
    } else if (b.disabled && !a.disabled) {
      return -1
    }

    return 0
  })
}

export const sortByCreated = (steps: CollectDataStep[]): CollectDataStep[] => {
  return steps.sort((a, b) => {
    if (a.status === CollectDataStepStatus.Created && b.status !== CollectDataStepStatus.Created) {
      return 1
    } else if (
      b.status === CollectDataStepStatus.Created &&
      a.status !== CollectDataStepStatus.Created
    ) {
      return -1
    }

    return 0
  })
}
